import { render } from "./ObjectEditDropdown.vue?vue&type=template&id=06e7208d"
import script from "./ObjectEditDropdown.vue?vue&type=script&lang=js"
export * from "./ObjectEditDropdown.vue?vue&type=script&lang=js"

import exportComponent from "/app/tmp/360pt/V3/v2026.19.r0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__